import { render, staticRenderFns } from "./UpsertDutyInfo.vue?vue&type=template&id=89ccba78&scoped=true&"
import script from "./UpsertDutyInfo.vue?vue&type=script&lang=ts&"
export * from "./UpsertDutyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UpsertDutyInfo.vue?vue&type=style&index=0&id=89ccba78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ccba78",
  null
  
)

export default component.exports